export class QueryParams {
  constructor(
    public page: number = 0,
    public size: number = 10,
    public perPage?: number,
    public total?: number,
    public name?: string,
    public role?: string,
    public courseId?: string,
    public organization?: string,
    public status?: string,
    public email?: string,
    public type?: string,
    public groupType?: string,
    public chapterName?: string,
    public learningObjectiveName?: string,
    public word?: string,
    public keywordRank?: string,
    public score?: string,
    public isEval?: string,
    public isGenerated?: string,
    public quantity?: number,
    public keyword?: boolean,
    public keywords?: boolean,
    public uuidTime?: boolean,
    public startTime?: boolean,
    public endTime?: boolean,
    public transcript?: boolean,
    public transcriptId?: string,
    public nameObject?: string,
    public classroomId?: string,
    public classroomName?: string,
    public done?: boolean,
    public sortedLikes?: string,
    public tag?: string,
    public title?: string,
    public orderBy?: string,
    public orderDir?: string,
    public denounceStatus?: string,
    public startDate?: string,
    public endDate?: string,
    public classroom?: string,
    public search?: string,
    public course?: string,
    public learningObjectiveId?:string
  ) {}
}

export class Pagination<T> {
  constructor(
    public content: T[] = [],
    public total: number = 0,
    public currentPage: number = 0,
    public size: number = 0,
    public totalActive: number = 0,
    public isHighlightedInLimit?: boolean,
    public results?: any
  ) {}
}
